import React from "react";

const SubmenuMessageIcon = () => {
  return (
    <svg
      width="93"
      height="93"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.1825 41.0515V58.8227C73.1825 59.9778 73.1379 61.0885 73.0043 62.1548C71.9798 74.1504 64.8971 80.1037 51.8455 80.1037H50.0638C48.9501 80.1037 47.8811 80.6369 47.2129 81.5254L41.8675 88.6339C39.5067 91.7883 35.6758 91.7883 33.3149 88.6339L27.9695 81.5254C27.3904 80.7701 26.0987 80.1037 25.1187 80.1037H23.337C9.1272 80.1037 2 76.5939 2 58.8227V41.0515C2 28.0342 8.01358 20.9701 19.9961 19.9483C21.0652 19.815 22.1788 19.7705 23.337 19.7705H51.8455C66.0553 19.7705 73.1825 26.879 73.1825 41.0515Z"
        stroke="#000"
        stroke-width="3.8"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M91.0001 23.281V41.0522C91.0001 54.114 84.9866 61.1336 73.0041 62.1554C73.1377 61.0892 73.1822 59.9785 73.1822 58.8233V41.0522C73.1822 26.8797 66.0551 19.7712 51.8454 19.7712H23.3369C22.1788 19.7712 21.0652 19.8156 19.9961 19.9489C21.0206 7.99782 28.1032 2 41.1546 2H69.6632C83.873 2 91.0001 9.10851 91.0001 23.281Z"
        stroke="#000"
        stroke-width="3.8"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.2061 51.9814H53.2645"
        stroke="#000"
        stroke-width="7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.6157 51.9814H37.6742"
        stroke="#000"
        stroke-width="7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.0254 51.9814H22.0911"
        stroke="#000"
        stroke-width="7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SubmenuMessageIcon;
